import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function TitleSemiBold({ children }) {
  return (
    <div className="title-semi-bold">{ children }</div>
  );
}
